import { useState, useEffect } from "react";

import { EMAIL_REGEX, PHONE_REGEX } from "common/constants/regex";

import Button from "client/common/components/buttons/Button";
import Form from "client/common/components/forms/Form";
import PasswordInput from "client/common/components/inputs/PasswordInput";
import { urls } from "client/routes";
import TextInput from "client/common/components/inputs/TextInput";

import LoginErrorAlert from "./LoginErrorAlert";
import { usePasswordLoginMutation } from "../../hooks";

import styles from "../../styles/LoginForm.module.less";

type LoginFormProps = {
  username?: string;
  next?: string;
};

const LoginForm = (props: LoginFormProps) => {
  const { username: initialUsername, next } = props;

  const {
    mutate: login,
    isLoading,
    isSuccess,
    error,
    reset,
  } = usePasswordLoginMutation(next || urls.home.root.to());

  const getInitialUsername = () => {
    if (initialUsername) {
      const maxEmailLength = 254;
      return initialUsername.slice(0, maxEmailLength + 1);
    }
    return "";
  };

  const [username, setUsername] = useState(getInitialUsername);
  const [password, setPassword] = useState("");

  useEffect(() => {
    // Hide the errors whenever the user is typing
    reset();
  }, [username, password, reset]);

  const canSubmit =
    !!(username && password) &&
    !!(username.match(EMAIL_REGEX) || username.match(PHONE_REGEX)) &&
    !isLoading;

  return (
    <Form
      className={styles.form}
      canSubmit={canSubmit}
      onSubmit={() => login({ username, password })}
    >
      {error && <LoginErrorAlert error={error} />}
      <TextInput label="Phone number or email" value={username} onChange={setUsername} />
      <PasswordInput
        label="Password"
        value={password}
        onChange={setPassword}
        passwordConditions={[]}
      />
      <Button type="submit" isLoading={isLoading || isSuccess} disabled={!canSubmit}>
        Login
      </Button>
    </Form>
  );
};

export default LoginForm;
